import { useOverviewContext } from '@resistapp/client/contexts/use-overview-context/use-overview-context';
import { OverviewDatum, getBeforeOrAfterAbundances } from '@resistapp/client/data-utils/plot-data/build-overview-line-data';
import { getFriendlyInterval } from '@resistapp/common/date-utils';
import { MetricMode } from '@resistapp/common/types';
import { ReductionMapLegend } from './reduction-map-legend';
import { ResistanceIndexMapLegend } from './resistance-index-map-legend';
import { RiskScoreMapLegend } from './risk-score-map-legend';

export function MapLegend({
  inline = false,
  data,
  showInfoIcon = false,
  enableContextualTip = false,
}: {
  inline?: boolean;
  data?: OverviewDatum[];
  showInfoIcon?: boolean;
  enableContextualTip?: boolean;
}) {
  const { metricMode, mapData, defaultProcessMode } = useOverviewContext();
  const legendData = data ?? mapData;
  if (!legendData) {
    return null;
  }
  const timeLegend = getFriendlyInterval(
    legendData.filter(d => getBeforeOrAfterAbundances(d, defaultProcessMode)?.length),
  );

  switch (metricMode) {
    case MetricMode.RISK:
      return (
        <RiskScoreMapLegend
          timeLegend={timeLegend}
          inline={inline}
          data={legendData}
          showInfoIcon={showInfoIcon}
          enableContextualTip={enableContextualTip}
        />
      );
    case MetricMode.ARGI:
      return (
        <ResistanceIndexMapLegend
          timeLegend={timeLegend}
          inline={inline}
          showInfoIcon={showInfoIcon}
          enableContextualTip={enableContextualTip}
        />
      );
    case MetricMode.REDUCTION:
      return (
        <ReductionMapLegend
          timeLegend={timeLegend}
          inline={inline}
          showInfoIcon={showInfoIcon}
          enableContextualTip={enableContextualTip}
        />
      );
    default:
      return null;
  }
}
